import React, { useState } from "react";
import "./MonthPicker.css";

function enumerateBetween(start: number, end: number): number[] {
  const result = [];
  for (let i = end; i >= start; i--) {
    result.push(i);
  }
  return result;
}

function getMonthNames() {
  const months: string[] = []; // an array to store the short month names
  for (let i = 0; i < 12; i++) {
    // loop through the numbers from 0 to 11
    const date = new Date(); // create a new Date object
    date.setMonth(i); // set the month of the Date object to the current number
    const shortMonthName = date.toLocaleString("en-US", { month: "short" }); // get the short month name using the en-US locale
    months.push(shortMonthName); // push the short month name to the array
  }
  return months;
}

export type Props = {
  yearRange: { minYear: number; maxYear: number };
  selectedMonth: Date;
  setSelectedMonth: (selectedMonth: Date) => void;
  startEndSelected: { start: Date; end: Date};
  type: "start" | "end"
};

export default function MonthPicker({
  yearRange,
  selectedMonth,
  setSelectedMonth,
  startEndSelected,
  type
}: Props) {
  const [visibleYear, setVisibleYear] = useState(selectedMonth.getFullYear());
  const onYearHeaderClicked = (year: number) => {
    if (year === visibleYear) {
      setVisibleYear(-1);
    } else {
      setVisibleYear(year);
    }
  };

  const onSelectMonth = (year: number, month: number) => {
    if((type === "start" && year < startEndSelected.end.getFullYear()) || (type === "end" && year > startEndSelected.end.getFullYear())) {
      setSelectedMonth(new Date(year, month))
    } else {
      if((type === "start" && month <= startEndSelected.end.getMonth() ) || (type === "end" && month >= startEndSelected.start.getMonth()) ) {
        setSelectedMonth(new Date(year, month))
      }
    }
  }
  return (
    <div className="month-picker-container">
      {enumerateBetween(yearRange.minYear, yearRange.maxYear).map((year) => {
        return (
          <div className="month-picker-year-container">
            <div
              className="month-picker-year-header"
              onClick={() => onYearHeaderClicked(year)}
            >
              <label>{year}</label>
              {year !== visibleYear && (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z"
                    fill="#313131"
                  />
                  <path
                    d="M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z"
                    fill="#313131"
                  />
                </svg>
              )}
              {year === visibleYear && (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 8L6 14L7.41 15.41L12 10.83L16.59 15.41L18 14L12 8Z"
                    fill="#313131"
                  />
                  <path
                    d="M12 8L6 14L7.41 15.41L12 10.83L16.59 15.41L18 14L12 8Z"
                    fill="#313131"
                  />
                </svg>
              )}
            </div>
            {year === visibleYear && (
              <div className="month-picker-month-buttons">
                {getMonthNames().map((monthName, month) => {
                  return (
                    <button
                      className={
                        "month-picker-month-button" +
                        (selectedMonth.getMonth() === month &&
                        selectedMonth.getFullYear() === year
                          ? " selected"
                          : "") + (
                            ((type === "start" && month > startEndSelected.end.getMonth() && year >= startEndSelected.end.getFullYear()) || (type === "end" && month < startEndSelected.start.getMonth() && year <= startEndSelected.start.getFullYear())) ? " disabled" : ""
                          )
                      }
                      style={{
                        gridArea: monthName,
                      }}
                      onClick={() => onSelectMonth(year, month)}
                    >
                      {monthName}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
